/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Note_Type_OutInputs */

const vi_pl_note_type_out = /** @type {(inputs: Pl_Note_Type_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất`)
};

/**

* @param {Pl_Note_Type_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_note_type_out = /** @type {((inputs?: Pl_Note_Type_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Note_Type_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_note_type_out(inputs)
});